import { connect } from 'react-redux';

import FreeShippingIndicator from 'components/FreeShippingIndicator';
import CartSelector from 'state/selectors/cart';
import Money from 'utils/Money';

const mapStateToProps = (state, ownProps) => {
  const cart = CartSelector.getCart(state);

  const cartValueRemaining = new Money(cart.valueRemainingForFreeShipping).format();
  const cartPercentageComplete = cart.percentageUntilFreeShipping;

  return {
    cartValueRemaining,
    cartPercentageComplete,
    ...ownProps,
  };
};

export default connect(mapStateToProps)(FreeShippingIndicator);
